export enum ContactPermissions {
  UPDATE_CONTACT = 'contacts.update',
}
